import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeeDocumentsListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import DocumentsAndFolders from 'modules/documents/components/DocumentsAndFolders'
import type { RouteContext } from 'modules/employees/lib/types'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DocumentsListPage = () => {
  const { navigation } = useNavigation()

  const { employee } = useOutletContext<RouteContext>()
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const employeeId = employee.attributes.id

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.employees.id.documents.list.documentId.fullPath({
        id: employeeId,
        document_id: id,
      }),
  }

  const { loading, data, error } = useQuery(EmployeeDocumentsListPageDocument, {
    variables: { employeeId: employeeId, companyId: companyId },
  })

  const canUploadDocument =
    (data?.employees?.employee?.folders?.some((folder) => folder._policies?.edit?.can) ?? false) ||
    (data?.employees?.employee?._policies?.editEmployeeDocumentsWithoutFolder?.can ?? false)
  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body showHeader={false} loading={loading} error={error}>
        <Box padding="s32">
          <DocumentsAndFolders
            parentRoute={navigation.employees.id.documents.list.fullPath({
              id: employeeId,
            })}
            canUploadDocument={canUploadDocument}
          />
        </Box>
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default DocumentsListPage
